import React, { JSX, useState } from "react";
import { Outlet } from "react-router";
import {
    UserSearchContext,
    UserSearchCriteria,
    defaultUserSearchCriteria,
} from "utilities/contexts/search/user/user-search-context";

interface AdminUserLayoutProps {}

const AdminUserLayout: React.FC<AdminUserLayoutProps> = (): JSX.Element => {
    const [userSearchCriteria, setUserSearchCriteria] = useState<UserSearchCriteria>(
        defaultUserSearchCriteria
    );

    return (
        <UserSearchContext.Provider
            value={{ initialCriteria: userSearchCriteria, setCriteria: setUserSearchCriteria }}>
            <Outlet />
        </UserSearchContext.Provider>
    );
};

export { AdminUserLayout };
